import React, { useContext } from 'react'
import '../../../styles/Header.scss'
import classNames from 'classnames'
import MenuContext from '../../../context'
import { DownArrow, LeftArrow, RightArrow } from '../../../svgs'
import { getDecrementedYear, getIncrementedYear } from '../../../../utils'
import { Pickers } from '../../../utils'

type HeaderProps = {
  className?: string
}

const { DAY_PICKER } = Pickers

const Header: React.FC<HeaderProps> = ({ className }) => {
  const headerClassNames = classNames('header', className)
  const { setCurrentDate, currentDate, setShowInMenu } = useContext(MenuContext)

  return (
    <header className={headerClassNames}>
      <LeftArrow
        className="header__arrow"
        onClick={() => setCurrentDate?.((oldVal) => getDecrementedYear(oldVal))}
      />
      <div
        className="header__heading"
        onClick={() => setShowInMenu?.(DAY_PICKER)}
      >
        <p>{currentDate?.year}</p>
        <DownArrow className="header__heading__rotated" />
      </div>
      <RightArrow
        className="header__arrow"
        onClick={() => setCurrentDate?.((oldVal) => getIncrementedYear(oldVal))}
      />
    </header>
  )
}
export default Header
